module.exports = __webpack_public_path__ + "static/img/004城市名片4.f6e7754.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/picImgs/004城市名片4.jpg
// module id = HNn4
// module chunks = 0